export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9357.48685b49.jpg";